export default __webpack_public_path__ + "static/media/boat.539798ee.jpg";